var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productInquiry" },
    [
      _c("product-inquiry-type-tab", {
        ref: "inquiryTypeTab",
        attrs: { nowShowType: _vm.nowShowType },
        on: { sumitBox: _vm.sumitBox, tabCheckType: _vm.tabCheckType },
      }),
      _vm.nowShowType == "hotel" || _vm.nowShowType == "site"
        ? _c("div", { staticClass: "sd_hotel_mod cleanFloat" }, [
            _c("div", { staticClass: "hotel_mod_left" }, [
              _vm.nowShowType == "hotel"
                ? _c("div", [
                    _c(
                      "div",
                      _vm._l(_vm.hotelData, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "mod_li",
                            class:
                              index == _vm.hotelChangeIndex ? "checkedLi" : "",
                            on: {
                              click: function ($event) {
                                return _vm.checkOneData(index)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "xuhao" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _c("b", [_vm._v(" 入住及离店日期： ")]),
                            _c("el-date-picker", {
                              attrs: {
                                "value-format": "yyyy-MM-dd",
                                size: "mini",
                                "unlink-panels": true,
                                clearable: false,
                                editable: false,
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeDate(item)
                                },
                              },
                              model: {
                                value: item.checkDate,
                                callback: function ($$v) {
                                  _vm.$set(item, "checkDate", $$v)
                                },
                                expression: "item.checkDate",
                              },
                            }),
                            _c("label", [
                              _vm._v(
                                "  " +
                                  _vm._s(_vm.getBetweenDay(item.checkDate)) +
                                  "晚"
                              ),
                            ]),
                            _c("city-autocomplete", { attrs: { obj: item } }),
                            _vm.hotelData.length > 1
                              ? _c("i", {
                                  staticClass: "el-icon-delete",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.delOneData(
                                        index,
                                        _vm.hotelData,
                                        1
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "infor_input" },
                      [
                        _c("ul", [
                          _c("li", { staticClass: "date_city_li" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.hotelData[_vm.hotelChangeIndex].startDate
                                ) +
                                  "  至  " +
                                  _vm._s(
                                    _vm.hotelData[_vm.hotelChangeIndex].endDate
                                  )
                              ),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getBetweenDay(
                                    _vm.hotelData[_vm.hotelChangeIndex]
                                      .checkDate
                                  )
                                ) + "晚"
                              ),
                            ]),
                            _vm.hotelData[_vm.hotelChangeIndex].cityId
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.hotelData[_vm.hotelChangeIndex]
                                        .cityName
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c("hotel-product-inquiry", {
                          attrs: {
                            hotelData: _vm.hotelData[_vm.hotelChangeIndex],
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "input_infor_show",
                        on: { click: _vm.addOneData },
                      },
                      [_vm._v("增加其他入住日期")]
                    ),
                  ])
                : _c("div", [
                    _c(
                      "ul",
                      { attrs: { id: "siteProjectInquiry" } },
                      _vm._l(_vm.siteData, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class:
                              index == _vm.siteChangeIndex ? "checkedLi" : "",
                            on: {
                              click: function ($event) {
                                return _vm.checkOneData(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "site_div_one" },
                              [
                                _c("b", [
                                  _vm._v(
                                    "亲，您需要在哪个城市举办这次会议/活动？"
                                  ),
                                ]),
                                _c("city-autocomplete", {
                                  attrs: {
                                    obj: item,
                                    width: "width: 1.8rem;margin-left: 0.1rem;",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "site_div_two" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "xuhao",
                                  staticStyle: { "margin-right": "0.05rem" },
                                },
                                [_vm._v(_vm._s(index + 1))]
                              ),
                              _c("b", [_vm._v("举办时间？")]),
                              _c(
                                "p",
                                { staticStyle: { "margin-left": "0.2rem" } },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: 1 },
                                      model: {
                                        value: item.dateType,
                                        callback: function ($$v) {
                                          _vm.$set(item, "dateType", $$v)
                                        },
                                        expression: "item.dateType",
                                      },
                                    },
                                    [_vm._v("有相对准确的日期")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: 2 },
                                      model: {
                                        value: item.dateType,
                                        callback: function ($$v) {
                                          _vm.$set(item, "dateType", $$v)
                                        },
                                        expression: "item.dateType",
                                      },
                                    },
                                    [_vm._v("有大致日期范围")]
                                  ),
                                ],
                                1
                              ),
                              _vm.siteData.length > 1
                                ? _c("i", {
                                    staticClass: "el-icon-delete",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delOneData(
                                          index,
                                          _vm.siteData,
                                          1
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "site_div_three" }, [
                              _c("p", [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.dateType === 1,
                                        expression: "item.dateType ===1",
                                      },
                                    ],
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: {
                                        width: "1.9rem",
                                        "margin-right": "0.15rem",
                                      },
                                      attrs: {
                                        type: "date",
                                        "unlink-panels": true,
                                        clearable: false,
                                        editable: false,
                                        size: "mini",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "选择日期",
                                      },
                                      model: {
                                        value: item.useDate,
                                        callback: function ($$v) {
                                          _vm.$set(item, "useDate", $$v)
                                        },
                                        expression: "item.useDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.dateType === 2,
                                        expression: "item.dateType === 2",
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "1.9rem",
                                          "margin-right": "0.15rem",
                                        },
                                        attrs: {
                                          placeholder: "请选择年",
                                          size: "mini",
                                        },
                                        model: {
                                          value: item.useYear,
                                          callback: function ($$v) {
                                            _vm.$set(item, "useYear", $$v)
                                          },
                                          expression: "item.useYear",
                                        },
                                      },
                                      _vm._l(_vm.yearOption, function (i) {
                                        return _c("el-option", {
                                          key: i + "年",
                                          attrs: { label: i + "年", value: i },
                                        })
                                      }),
                                      1
                                    ),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "1.9rem",
                                          "margin-right": "0.15rem",
                                        },
                                        attrs: {
                                          placeholder: "请选择月",
                                          size: "mini",
                                        },
                                        model: {
                                          value: item.useMonth,
                                          callback: function ($$v) {
                                            _vm.$set(item, "useMonth", $$v)
                                          },
                                          expression: "item.useMonth",
                                        },
                                      },
                                      _vm._l(12, function (i) {
                                        return _c("el-option", {
                                          key: i + "月",
                                          attrs: { label: i + "月", value: i },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "1.9rem" },
                                        attrs: {
                                          placeholder: "请选择天数",
                                          size: "mini",
                                        },
                                        model: {
                                          value: item.useDay,
                                          callback: function ($$v) {
                                            _vm.$set(item, "useDay", $$v)
                                          },
                                          expression: "item.useDay",
                                        },
                                      },
                                      _vm._l(
                                        _vm.durationOption,
                                        function (text) {
                                          return _c("el-option", {
                                            key: text,
                                            attrs: { label: text, value: text },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "site_infor" },
                      [
                        _c("site-product-inquiry", {
                          attrs: {
                            siteData: _vm.siteData[_vm.siteChangeIndex],
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "input_infor_show",
                        on: { click: _vm.addOneData },
                      },
                      [_vm._v("增加其他会议日期")]
                    ),
                  ]),
            ]),
            _c("div", { staticClass: "hotel_mod_right" }, [
              _vm.nowShowType == "hotel"
                ? _c(
                    "ul",
                    _vm._l(_vm.hotelData, function (item, index) {
                      return _c("li", { key: index }, [
                        _c("div", { staticClass: "hmr_left" }, [
                          _c("b", [_vm._v(_vm._s(index + 1))]),
                          _vm._m(0, true),
                        ]),
                        _c(
                          "div",
                          { staticClass: "hmr_right" },
                          [
                            _c("p", [
                              item.checkDate.length > 0
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.checkDate[0]) +
                                        "  至  " +
                                        _vm._s(item.checkDate[1]) +
                                        "   " +
                                        _vm._s(
                                          _vm.getBetweenDay(item.checkDate)
                                        ) +
                                        "晚  "
                                    ),
                                    item.cityId
                                      ? _c("span", [
                                          _vm._v(_vm._s(item.cityName)),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("hotel-product-inquiry-show", {
                              attrs: { hotelData: item },
                            }),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                : _c(
                    "ul",
                    _vm._l(_vm.siteData, function (item, index) {
                      return _c("li", { key: index }, [
                        _c("div", { staticClass: "hmr_left" }, [
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index != 0,
                                expression: "index!=0",
                              },
                            ],
                            staticClass: "left_line",
                          }),
                          _c("b", [_vm._v(_vm._s(index + 1))]),
                          _vm._m(1, true),
                        ]),
                        _c(
                          "div",
                          { staticClass: "hmr_right" },
                          [
                            item.dateType == 1
                              ? [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.useDate != "" ||
                                            item.useDay != "",
                                          expression:
                                            "item.useDate!=''||item.useDay!=''",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(" " + _vm._s(item.useDate)),
                                      _c("i", [_vm._v("/")]),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            item.dateType == 2
                              ? [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.useYear != "" ||
                                            item.useDay != "",
                                          expression:
                                            "item.useYear!=''||item.useDay!=''",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.useYear) +
                                          "-" +
                                          _vm._s(item.useMonth)
                                      ),
                                      _c("i", [_vm._v("/")]),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _c("site-product-inquiry-show", {
                              attrs: { item: item },
                            }),
                          ],
                          2
                        ),
                      ])
                    }),
                    0
                  ),
            ]),
          ])
        : _c("div", { staticClass: "bus_outSide_box" }, [
            _vm.nowShowType == "spot"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.spotData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("景点")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.spotData.spotProductInquiryList,
                              function (spotItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c("b", { staticClass: "needText" }, [
                                          _vm._v("亲,您需要"),
                                        ])
                                      : _vm._e(),
                                    index != 0
                                      ? _c("div", { staticClass: "special" }, [
                                          _c(
                                            "i",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: spotItem.addType != "",
                                                  expression:
                                                    "spotItem.addType!=''",
                                                },
                                              ],
                                              staticClass: "andOr",
                                            },
                                            [_vm._v(_vm._s(spotItem.addType))]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "1.5rem" },
                                          attrs: {
                                            type: "date",
                                            "unlink-panels": true,
                                            clearable: false,
                                            editable: false,
                                            size: "mini",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "请选择日期",
                                          },
                                          model: {
                                            value: spotItem.useDate,
                                            callback: function ($$v) {
                                              _vm.$set(spotItem, "useDate", $$v)
                                            },
                                            expression: "spotItem.useDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: spotItem,
                                            width: "width: 1.3rem;",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.1rem",
                                        },
                                      },
                                      [
                                        _c("spot-autocomplete", {
                                          attrs: { spotItem: spotItem },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value: spotItem.spotType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  spotItem,
                                                  "spotType",
                                                  $$v
                                                )
                                              },
                                              expression: "spotItem.spotType",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "散客票" } },
                                              [_vm._v("散客票")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "团队票" } },
                                              [_vm._v("团队票")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "专业讲解" } },
                                              [_vm._v("专业讲解")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        addObj: _vm.spotProductInquiryList,
                                        arr: _vm.spotData
                                          .spotProductInquiryList,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.85rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.spotData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.spotData, "remarks", $$v)
                                  },
                                  expression: "spotData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.spotData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "traffic"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.trafficData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("车型")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.trafficData.trafficProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "1.83rem" },
                                          },
                                          [_vm._v("亲，您需要的车型是？")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: { width: "1.83rem" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("traffic-product-inquiry", {
                                      attrs: { carItem: carItem },
                                    }),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.trafficData
                                          .trafficProductInquiries,
                                        addObj: _vm.trafficProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "1.83rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "如果您需要的不是上面的车型，请填写您需要什么样的车？和其他备注说明",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.trafficData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.trafficData, "remarks", $$v)
                                  },
                                  expression: "trafficData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.trafficData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "communication"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", {
                      attrs: { spotData: _vm.communicationData },
                    }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("交通")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.communicationData.bigTrafficProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c("b", { staticClass: "needText" }, [
                                          _vm._v("亲,您需要"),
                                        ])
                                      : _vm._e(),
                                    index != 0
                                      ? _c("div", { staticClass: "special" }, [
                                          _c(
                                            "i",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: carItem.addType != "",
                                                  expression:
                                                    "carItem.addType!=''",
                                                },
                                              ],
                                              staticClass: "andOr",
                                            },
                                            [_vm._v(_vm._s(carItem.addType))]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "1rem" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                            },
                                            model: {
                                              value: carItem.trafficType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "trafficType",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.trafficType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.communicationOptionOne,
                                            function (text, i) {
                                              return _c("el-option", {
                                                key: i,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            width: "width: 1.4rem;",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            width: "width: 1.4rem;",
                                            nameProName: "endCityName",
                                            idProName: "endCityId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "1.4rem" },
                                          attrs: {
                                            type: "date",
                                            "unlink-panels": true,
                                            clearable: false,
                                            editable: false,
                                            size: "mini",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "出发日期",
                                          },
                                          model: {
                                            value: carItem.useDate,
                                            callback: function ($$v) {
                                              _vm.$set(carItem, "useDate", $$v)
                                            },
                                            expression: "carItem.useDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "2.1rem" },
                                          attrs: {
                                            placeholder:
                                              "期望的班(船)/次或时间",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.expectFlight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                carItem,
                                                "expectFlight",
                                                $$v
                                              )
                                            },
                                            expression: "carItem.expectFlight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.communicationData
                                          .bigTrafficProductInquiries,
                                        addObj: _vm.bigTrafficProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.85rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "亲，正常会都按照经济舱报价，如有特殊舱位需求、或其他特殊需求等（如VIP通道等），请在此备注，我们将会按照要求，为您安排合适的产品",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.communicationData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.communicationData,
                                      "remarks",
                                      $$v
                                    )
                                  },
                                  expression: "communicationData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "restaurant"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", {
                      attrs: { spotData: _vm.restaurantData },
                    }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("餐食")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.restaurantData.mealProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "0.98rem" },
                                          },
                                          [_vm._v("亲，您需要")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: { width: "0.98rem" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            width: "width: 1.5rem;",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "0.77rem" },
                                          attrs: {
                                            placeholder: "请填写",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              carItem.number =
                                                carItem.number.replace(
                                                  /[^\d]/g,
                                                  ""
                                                )
                                            },
                                          },
                                          model: {
                                            value: carItem.number,
                                            callback: function ($$v) {
                                              _vm.$set(carItem, "number", $$v)
                                            },
                                            expression: "carItem.number",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [_vm._v("顿")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "1rem" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                            },
                                            model: {
                                              value: carItem.mealType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "mealType",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.mealType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.restaurantOptionOne,
                                            function (text, i) {
                                              return _c("el-option", {
                                                key: i,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    carItem.mealType && carItem.mealType != ""
                                      ? _c(
                                          "span",
                                          { staticClass: "selectSpan" },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "1rem" },
                                              attrs: {
                                                placeholder: "菜品名称",
                                                size: "mini",
                                              },
                                              model: {
                                                value: carItem.meal,
                                                callback: function ($$v) {
                                                  _vm.$set(carItem, "meal", $$v)
                                                },
                                                expression: "carItem.meal",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "1rem" },
                                          attrs: {
                                            placeholder: "预算（如有）",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.budgetPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                carItem,
                                                "budgetPrice",
                                                $$v
                                              )
                                            },
                                            expression: "carItem.budgetPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "selectSpan" },
                                      [
                                        _c("currency-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            sizeType: "small",
                                            styleStr: "width:1rem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.restaurantData
                                          .mealProductInquiries,
                                        addObj: _vm.mealProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.99rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "如您需其他用餐类型,或您有指定想询价的餐厅,请在此填写具体需求(城市、用餐时间、餐厅名称等),我们将尽快为您提供您需要的专属特价",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.restaurantData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.restaurantData, "remarks", $$v)
                                  },
                                  expression: "restaurantData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.restaurantData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "guide"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.guideData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("导服")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.guideData.trafficProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "0.98rem" },
                                          },
                                          [_vm._v("亲，您需要")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: { width: "0.98rem" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "1rem" },
                                          attrs: {
                                            placeholder: "",
                                            size: "mini",
                                          },
                                          on: {
                                            input: function ($event) {
                                              carItem.busNumber =
                                                carItem.busNumber.replace(
                                                  /[^\d]/g,
                                                  ""
                                                )
                                            },
                                          },
                                          model: {
                                            value: carItem.busNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                carItem,
                                                "busNumber",
                                                $$v
                                              )
                                            },
                                            expression: "carItem.busNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [_vm._v("位")]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value: carItem.trafficType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "trafficType",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.trafficType",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: "全陪兼地陪" },
                                              },
                                              [_vm._v("全陪兼地陪")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "地接导游" } },
                                              [_vm._v("地接导游")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "伴游" } },
                                              [_vm._v("伴游")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "专业讲解" } },
                                              [_vm._v("专业讲解")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              carItem.trafficType == "专业讲解",
                                            expression:
                                              "carItem.trafficType=='专业讲解'",
                                          },
                                        ],
                                        staticClass: "selectSpan",
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "1.9rem" },
                                          attrs: {
                                            placeholder: "请填写需要专讲的景点",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.busType,
                                            callback: function ($$v) {
                                              _vm.$set(carItem, "busType", $$v)
                                            },
                                            expression: "carItem.busType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.guideData
                                          .trafficProductInquiries,
                                        addObj: _vm.trafficProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.99rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "如果您需要的不是上面的导游类型，请填写您需要什么样的导游？和其他备注说明",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.guideData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.guideData, "remarks", $$v)
                                  },
                                  expression: "guideData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.guideData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "visa"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.visaData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("签证")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.visaData.visaProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "0.3rem" },
                                          },
                                          [_vm._v("亲")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: {
                                              width: "0.4rem",
                                              "margin-left": "-0.1rem",
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            searchType: 0,
                                            idProName: "countryId",
                                            nameProName: "countryName",
                                            width: "width: 1.8rem;",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [_vm._v("您申请的是")]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                            },
                                            model: {
                                              value: carItem.visaType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "visaType",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.visaType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.visaOptionOne,
                                            function (text, i) {
                                              return _c("el-option", {
                                                key: i,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                            },
                                            model: {
                                              value: carItem.visaContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "visaContent",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.visaContent",
                                            },
                                          },
                                          _vm._l(
                                            _vm.visaOptionTwo,
                                            function (text, i) {
                                              return _c("el-option", {
                                                key: i,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.visaData.visaProductInquiries,
                                        addObj: _vm.visaProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.3rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.visaData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.visaData, "remarks", $$v)
                                  },
                                  expression: "visaData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.visaData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "business"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.businessData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("商务")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.businessData.businessProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass: "li",
                                    staticStyle: { display: "block" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        index == 0
                                          ? _c(
                                              "b",
                                              {
                                                staticClass: "needText",
                                                staticStyle: {
                                                  width: "1.4rem",
                                                },
                                              },
                                              [_vm._v("亲，您需要的是")]
                                            )
                                          : _vm._e(),
                                        index != 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "special",
                                                staticStyle: {
                                                  width: "1.4rem",
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          carItem.addType != "",
                                                        expression:
                                                          "carItem.addType!=''",
                                                      },
                                                    ],
                                                    staticClass: "andOr",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(carItem.addType)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: "商务拜访" },
                                            model: {
                                              value: carItem.businessType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "businessType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "carItem.businessType",
                                            },
                                          },
                                          [_vm._v("商务拜访")]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: "邀请函及商务联系",
                                            },
                                            model: {
                                              value: carItem.businessType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "businessType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "carItem.businessType",
                                            },
                                          },
                                          [_vm._v("邀请函及商务联系")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "selectSpan",
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          "margin-left": "1.38rem",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "0.05rem",
                                            },
                                          },
                                          [
                                            _c("city-autocomplete", {
                                              attrs: {
                                                obj: carItem,
                                                width: "width: 1rem;",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("el-input", {
                                          staticStyle: {
                                            width: "1.4rem",
                                            "margin-right": "0.05rem",
                                          },
                                          attrs: {
                                            placeholder:
                                              carItem.businessType == "商务拜访"
                                                ? "您想拜访的行业"
                                                : "您的对口行业",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.businessIndustry,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                carItem,
                                                "businessIndustry",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "carItem.businessIndustry",
                                          },
                                        }),
                                        _c("el-input", {
                                          staticStyle: {
                                            width: "2.3rem",
                                            "margin-right": "0.05rem",
                                          },
                                          attrs: {
                                            placeholder:
                                              carItem.businessType == "商务拜访"
                                                ? "拜访时间和拜访时长"
                                                : "邀请时间和邀请时长",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.time,
                                            callback: function ($$v) {
                                              _vm.$set(carItem, "time", $$v)
                                            },
                                            expression: "carItem.time",
                                          },
                                        }),
                                        _c("el-input", {
                                          staticStyle: {
                                            width: "2.1rem",
                                            "margin-right": "0.05rem",
                                          },
                                          attrs: {
                                            placeholder: "要求及拜访目的",
                                            size: "mini",
                                          },
                                          model: {
                                            value: carItem.objective,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                carItem,
                                                "objective",
                                                $$v
                                              )
                                            },
                                            expression: "carItem.objective",
                                          },
                                        }),
                                        _c("operation-button", {
                                          attrs: {
                                            arr: _vm.businessData
                                              .businessProductInquiries,
                                            addObj:
                                              _vm.businessProductInquiries,
                                            index: index,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "1.38rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请在此处填写其他您想告知我们的需求，我们的商务专家将会尽快和您联系",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.businessData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.businessData, "remarks", $$v)
                                  },
                                  expression: "businessData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.businessData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "charact"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.charactData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("体验")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.charactData.chractProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "1.35rem" },
                                          },
                                          [_vm._v("亲，您想在什么")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: { width: "1.35rem" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            width: "width:2rem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.2rem",
                                        },
                                      },
                                      [_vm._v("城市")]
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [_vm._v("安排什么特色体验")]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                              "allow-create": "",
                                              filterable: "",
                                            },
                                            model: {
                                              value: carItem.content,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "content",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.content",
                                            },
                                          },
                                          _vm._l(
                                            _vm.charactOptionOne,
                                            function (text, index1) {
                                              return _c("el-option", {
                                                key: index1,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.charactData
                                          .chractProductInquiries,
                                        addObj: _vm.chractProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.3rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请在此处填写其他您想告知我们的需求，我们会尽快为您安排合适的产品",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.charactData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.charactData, "remarks", $$v)
                                  },
                                  expression: "charactData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.charactData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.nowShowType == "service"
              ? _c(
                  "div",
                  { staticClass: "bus_mod_box" },
                  [
                    _c("people-box", { attrs: { spotData: _vm.serviceData } }),
                    _c("div", { staticClass: "car_type_box spot_type_box" }, [
                      _c("b", [_vm._v("服务")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0.2rem 0rem 0.2rem 0rem",
                            width: "9.45rem",
                          },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.serviceData.chractProductInquiries,
                              function (carItem, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "li" },
                                  [
                                    index == 0
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "needText",
                                            staticStyle: { width: "1.35rem" },
                                          },
                                          [_vm._v("亲，您想在什么")]
                                        )
                                      : _vm._e(),
                                    index != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "special",
                                            staticStyle: { width: "1.35rem" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      carItem.addType != "",
                                                    expression:
                                                      "carItem.addType!=''",
                                                  },
                                                ],
                                                staticClass: "andOr",
                                              },
                                              [_vm._v(_vm._s(carItem.addType))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      [
                                        _c("city-autocomplete", {
                                          attrs: {
                                            obj: carItem,
                                            width: "width:2rem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.2rem",
                                        },
                                      },
                                      [_vm._v("城市")]
                                    ),
                                    _c(
                                      "b",
                                      {
                                        staticStyle: {
                                          "margin-right": "0.05rem",
                                        },
                                      },
                                      [_vm._v("安排什么服务")]
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              placeholder: "请选择",
                                              size: "mini",
                                            },
                                            model: {
                                              value: carItem.content,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  carItem,
                                                  "content",
                                                  $$v
                                                )
                                              },
                                              expression: "carItem.content",
                                            },
                                          },
                                          _vm._l(
                                            _vm.serviceOptionOne,
                                            function (text, index1) {
                                              return _c("el-option", {
                                                key: index1,
                                                attrs: {
                                                  label: text,
                                                  value: text,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("operation-button", {
                                      attrs: {
                                        arr: _vm.serviceData
                                          .chractProductInquiries,
                                        addObj: _vm.chractProductInquiries,
                                        index: index,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "p",
                            { staticStyle: { "margin-left": "0.3rem" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "如上述产品不符合您的需求，请在此处填写您的需求，我们会尽快为您安排合适的产品",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.serviceData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.serviceData, "remarks", $$v)
                                  },
                                  expression: "serviceData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("router-box", {
                      attrs: {
                        spotData: _vm.serviceData,
                        yearOption: _vm.yearOption,
                        inquiryPlanObj: _vm.inquiryPlanObj,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
      _c("send-inquiry-dialog", {
        ref: "sendInquiry",
        attrs: { identity: "供应商" },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i"),
      _c("span", { staticClass: "el-icon-caret-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i"),
      _c("span", { staticClass: "el-icon-caret-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }